export const heroData = {
  tag: "每日更新 · 海量资源",
  h1: "国产91视频 — 手机看视频移动端播放首选平台",
  slogan: "糖心视频 / 黑桃视频 / 妖精视频 / 桃花视频 一站聚合",
  description: "国产91视频汇集糖心视频、黑桃视频、妖精视频、桃花视频等热门视频APP资源，为移动端用户提供便捷的手机看视频体验。站内每日更新最新视频内容，覆盖多元题材，支持高清流畅播放与离线缓存。无论您偏好哪种风格，都能在这里找到心仪的视频软件，随时随地畅享移动端播放乐趣。",
  stats: [
    { label: "主题分类", value: "30+" },
    { label: "视频资源", value: "10万+" },
    { label: "合作APP", value: "50+" },
  ],
  primaryCta: { text: "立即下载APP", href: "#app" },
  secondaryCta: { text: "查看热门话题", href: "#topics" },
};

export const mediaData = [
  {
    id: 1,
    title: "糖心视频 · 精品推荐合集",
    duration: "32:15",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20in%20hand%20displaying%20high%20quality%20video%20player%20interface%20with%20play%20button%2C%20warm%20ambient%20indoor%20lighting%2C%20cozy%20evening%20atmosphere%2C%20soft%20bokeh%20background%2C%20cinematic%20color%20grading%20with%20coral%20and%20amber%20tones%2C%20editorial%20tech%20photography%2C%20clean%20minimal%20composition&width=640&height=360&seq=media-thumb-01&orientation=landscape",
    tag: "热门",
  },
  {
    id: 2,
    title: "黑桃视频 · 最新上线内容",
    duration: "18:42",
    thumbnail: "https://readdy.ai/api/search-image?query=Elegant%20tablet%20device%20on%20wooden%20surface%20showing%20dark%20themed%20video%20streaming%20app%20interface%2C%20warm%20desk%20lamp%20glow%2C%20coffee%20cup%20nearby%2C%20evening%20mood%2C%20sophisticated%20interior%20with%20bookshelf%20background%2C%20amber%20and%20deep%20brown%20color%20palette%2C%20lifestyle%20tech%20photography&width=640&height=360&seq=media-thumb-02&orientation=landscape",
    tag: "新番",
  },
  {
    id: 3,
    title: "妖精视频 · 人气精选放送",
    duration: "25:08",
    thumbnail: "https://readdy.ai/api/search-image?query=Smartphone%20on%20minimal%20desk%20with%20video%20app%20home%20screen%20displaying%20content%20thumbnails%2C%20natural%20daylight%20from%20window%2C%20clean%20white%20workspace%2C%20plant%20decoration%2C%20modern%20lifestyle%20aesthetic%2C%20soft%20shadows%2C%20warm%20neutral%20tones%2C%20editorial%20photography&width=640&height=360&seq=media-thumb-03&orientation=landscape",
    tag: "精选",
  },
];

export const faqData = [
  {
    id: 1,
    question: "国产91视频平台支持哪些移动端设备？",
    answer: "国产91视频全面适配iOS和Android系统，支持手机、平板等各类移动端设备。无论您使用iPhone、华为、小米、OPPO还是vivo，都能流畅观看糖心视频、黑桃视频等所有内容，提供一致的高清播放体验。",
  },
  {
    id: 2,
    question: "糖心视频和黑桃视频有什么区别？",
    answer: "糖心视频主打精品短剧与情感题材，画风温馨细腻；黑桃视频侧重悬疑推理与剧情深度，节奏紧凑。两个APP各有特色，您可以根据个人喜好选择，也可以同时下载畅享不同风格内容。",
  },
  {
    id: 3,
    question: "如何下载妖精视频和桃花视频APP？",
    answer: "在本站#app区域即可找到妖精视频和桃花视频的下载入口页面。所有推荐的视频软件均经过安全检测，支持一键跳转下载，安装便捷，无需复杂配置即可开始手机看视频。",
  },
  {
    id: 4,
    question: "视频播放是否需要注册登录？",
    answer: "大部分视频APP支持游客模式浏览，无需注册即可观看部分内容。注册登录后可解锁高清画质、离线缓存、收藏列表等更多功能，推荐使用手机号快速注册获得完整体验。",
  },
  {
    id: 5,
    question: "移动端播放流量消耗大吗？",
    answer: "各视频APP均提供智能码率调节功能，在移动网络下自动优化播放质量，有效节省流量。同时支持Wi-Fi环境下预先缓存，外出时离线观看零流量消耗，让您随时随地放心看。",
  },
];

export const topicsData = [
  { id: 1, name: "糖心视频", count: "2.8万讨论", hot: true },
  { id: 2, name: "黑桃视频新番", count: "1.6万讨论", hot: true },
  { id: 3, name: "妖精视频推荐", count: "3.2万讨论", hot: true },
  { id: 4, name: "桃花视频合集", count: "2.1万讨论", hot: false },
  { id: 5, name: "手机看视频技巧", count: "1.2万讨论", hot: false },
  { id: 6, name: "视频APP测评", count: "9.8千讨论", hot: false },
  { id: 7, name: "移动端播放", count: "1.5万讨论", hot: true },
  { id: 8, name: "离线缓存攻略", count: "8.3千讨论", hot: false },
  { id: 9, name: "高清资源分享", count: "2.4万讨论", hot: true },
];

export const carouselData = [
  {
    id: 1,
    title: "糖心视频 · 夏日特辑",
    description: "精选糖心视频夏季人气作品，清新治愈风格，适合闲暇时光慢慢品味。每日更新，持续放送高分内容。",
    image: "https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20scene%20with%20smartphone%20on%20outdoor%20wooden%20table%20displaying%20colorful%20video%20app%20interface%2C%20sunset%20golden%20hour%20light%2C%20green%20garden%20background%2C%20refreshing%20drink%20nearby%2C%20relaxing%20summer%20vibe%2C%20cinematic%20warm%20tones%2C%20lifestyle%20photography%2C%20soft%20natural%20bokeh&width=800&height=450&seq=carousel-01&orientation=landscape",
    tag: "热门专题",
  },
  {
    id: 2,
    title: "黑桃视频 · 悬疑剧场",
    description: "黑桃视频悬疑推理专场，汇集高智商犯罪、密室逃脱、侦探破案等烧脑内容，挑战你的推理极限。",
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20tablet%20on%20desk%20displaying%20mystery%20themed%20video%20thumbnail%20with%20dramatic%20lighting%2C%20dim%20room%20with%20warm%20desk%20lamp%2C%20notebook%20and%20pen%20alongside%2C%20noir%20atmosphere%2C%20deep%20amber%20and%20shadow%20tones%2C%20cinematic%20photography%2C%20mysterious%20ambiance&width=800&height=450&seq=carousel-02&orientation=landscape",
    tag: "悬疑专题",
  },
  {
    id: 3,
    title: "妖精视频 · 人气排行",
    description: "妖精视频站内人气榜TOP作品一网打尽，涵盖都市、校园、古风等多元题材，看看大家都在追什么。",
    image: "https://readdy.ai/api/search-image?query=Bright%20modern%20living%20room%20with%20large%20screen%20device%20showing%20trending%20video%20rankings%20interface%2C%20cozy%20sofa%20with%20cushions%2C%20warm%20natural%20daylight%2C%20indoor%20plants%2C%20clean%20scandinavian%20decor%2C%20soft%20pastel%20accents%2C%20lifestyle%20interior%20photography%2C%20comfortable%20viewing%20atmosphere&width=800&height=450&seq=carousel-03&orientation=landscape",
    tag: "人气专题",
  },
  {
    id: 4,
    title: "桃花视频 · 浪漫剧场",
    description: "桃花视频浪漫爱情剧场，从甜蜜邂逅到深情告白，高甜剧情让你一次看过瘾，温暖每一个心动瞬间。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20evening%20setting%20with%20smartphone%20on%20soft%20blanket%20displaying%20romance%20themed%20video%20content%2C%20fairy%20lights%20in%20background%2C%20warm%20candlelight%20glow%2C%20cozy%20bedroom%20atmosphere%2C%20soft%20pink%20and%20warm%20amber%20color%20palette%2C%20dreamy%20bokeh%20effect%2C%20intimate%20lifestyle%20photography&width=800&height=450&seq=carousel-04&orientation=landscape",
    tag: "浪漫专题",
  },
  {
    id: 5,
    title: "移动端播放 · 体验升级",
    description: "最新视频APP版本全面优化移动端播放体验，支持画中画、倍速播放、弹幕互动等功能，让手机看视频更尽兴。",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20held%20in%20hands%20displaying%20advanced%20video%20player%20controls%20with%20speed%20settings%20and%20quality%20options%2C%20clean%20minimalist%20desk%20setup%2C%20daylight%20from%20window%2C%20professional%20tech%20review%20aesthetic%2C%20sharp%20details%20on%20screen%2C%20warm%20neutral%20background%2C%20editorial%20product%20photography&width=800&height=450&seq=carousel-05&orientation=landscape",
    tag: "体验专题",
  },
];

export const appData = {
  title: "国产91视频 · 移动端APP下载",
  description: "支持iOS与Android双平台，糖心视频、黑桃视频、妖精视频、桃花视频等热门视频软件一应俱全。扫描二维码或在应用商店搜索对应名称即可下载安装，开启您的手机看视频之旅。",
  qrImage: "https://readdy.ai/api/search-image?query=Clean%20minimal%20QR%20code%20design%20on%20white%20background%20with%20subtle%20gradient%20border%2C%20modern%20app%20download%20graphic%2C%20soft%20coral%20and%20warm%20gray%20accents%2C%20professional%20clean%20look%2C%20centered%20composition%2C%20high%20contrast%20for%20scanning&width=400&height=400&seq=app-qr-01&orientation=squarish",
  badges: [
    { name: "糖心视频", icon: "ri-heart-pulse-line" },
    { name: "黑桃视频", icon: "ri-movie-2-line" },
    { name: "妖精视频", icon: "ri-fire-line" },
    { name: "桃花视频", icon: "ri-flower-line" },
  ],
};

export const cardsData = [
  {
    id: 1,
    title: "糖心视频：温馨治愈首选",
    description: "糖心视频以高品质短剧为核心，画风细腻情感丰富。无论是温情故事还是轻喜剧情，都能在这里找到属于你的那份感动。支持高清播放与离线下载。",
    image: "https://readdy.ai/api/search-image?query=Warm%20cozy%20scene%20of%20person%20watching%20heartwarming%20video%20on%20smartphone%20in%20comfortable%20cafe%20corner%2C%20soft%20afternoon%20sunlight%20through%20window%2C%20steaming%20drink%20nearby%2C%20relaxed%20atmosphere%2C%20coral%20and%20cream%20color%20palette%2C%20lifestyle%20photography%2C%20gentle%20mood&width=600&height=400&seq=cards-01&orientation=landscape",
    tag: "糖心视频",
  },
  {
    id: 2,
    title: "黑桃视频：烧脑悬疑盛宴",
    description: "黑桃视频专注悬疑推理类内容，高能反转、缜密逻辑让人欲罢不能。每部作品都经过精心挑选，保证剧情质量与观影体验。",
    image: "https://readdy.ai/api/search-image?query=Dark%20themed%20tablet%20screen%20showing%20thriller%20video%20content%20with%20dramatic%20scene%2C%20dim%20lighting%20in%20modern%20study%20room%2C%20bookshelf%20background%2C%20intense%20moody%20atmosphere%2C%20deep%20amber%20and%20charcoal%20tones%2C%20cinematic%20photography%2C%20suspenseful%20vibe&width=600&height=400&seq=cards-02&orientation=landscape",
    tag: "黑桃视频",
  },
  {
    id: 3,
    title: "妖精视频：多元潮流汇聚",
    description: "妖精视频汇集都市、校园、古风等多元题材，紧跟潮流热点。每日更新海量内容，满足不同口味的观影需求，是发现新内容的最佳平台。",
    image: "https://readdy.ai/api/search-image?query=Colorful%20smartphone%20screen%20displaying%20diverse%20video%20categories%20grid%20with%20vibrant%20thumbnails%2C%20held%20in%20hand%20against%20bright%20urban%20cafe%20background%2C%20daylight%2C%20trendy%20lifestyle%20setting%2C%20energetic%20vibe%2C%20warm%20and%20vibrant%20color%20palette%2C%20editorial%20photography&width=600&height=400&seq=cards-03&orientation=landscape",
    tag: "妖精视频",
  },
  {
    id: 4,
    title: "桃花视频：浪漫甜蜜时光",
    description: "桃花视频主打浪漫爱情与甜蜜剧情，高颜值演员阵容加上走心剧本，为观众打造沉浸式恋爱观影体验，是放松心情的绝佳选择。",
    image: "https://readdy.ai/api/search-image?query=Soft%20romantic%20scene%20with%20smartphone%20on%20bed%20displaying%20romance%20video%20thumbnail%2C%20fairy%20lights%20in%20blurred%20background%2C%20pink%20and%20warm%20white%20color%20scheme%2C%20cozy%20bedroom%20atmosphere%2C%20dreamy%20soft%20focus%2C%20lifestyle%20photography%2C%20gentle%20romantic%20mood&width=600&height=400&seq=cards-04&orientation=landscape",
    tag: "桃花视频",
  },
  {
    id: 5,
    title: "移动端播放：随时随地畅享",
    description: "所有视频APP均针对手机看视频移动端播放深度优化，支持智能码率、画中画、倍速调节等功能。Wi-Fi缓存、省流模式让您放心追剧。",
    image: "https://readdy.ai/api/search-image?query=Person%20comfortably%20watching%20video%20on%20smartphone%20during%20commute%20on%20modern%20train%2C%20natural%20daylight%20through%20window%2C%20wireless%20earbuds%20visible%2C%20clean%20modern%20interior%2C%20dynamic%20urban%20lifestyle%2C%20warm%20natural%20tones%2C%20editorial%20photography%2C%20motion%20blur%20background&width=600&height=400&seq=cards-05&orientation=landscape",
    tag: "视频软件",
  },
];

export const rankingData = [
  { id: 1, title: "糖心视频 · 夏日治愈系列合集", heat: "9.8", tag: "糖心视频" },
  { id: 2, title: "黑桃视频 · 高能反转悬疑短剧", heat: "9.6", tag: "黑桃视频" },
  { id: 3, title: "妖精视频 · 都市情感人气TOP", heat: "9.5", tag: "妖精视频" },
  { id: 4, title: "桃花视频 · 古风浪漫新作上线", heat: "9.3", tag: "桃花视频" },
  { id: 5, title: "移动端播放 · 画中画功能指南", heat: "9.1", tag: "视频软件" },
  { id: 6, title: "苹果视频 · 校园青春热播榜", heat: "8.9", tag: "苹果视频" },
];

export const updatesData = [
  { id: 1, date: "07-30", title: "糖心视频「夏日特辑」全新上线，每周更新3集", tag: "上新" },
  { id: 2, date: "07-29", title: "黑桃视频悬疑剧场新增5部高能推理作品", tag: "上新" },
  { id: 3, date: "07-28", title: "妖精视频APP发布v3.2版本，优化移动端播放体验", tag: "更新" },
  { id: 4, date: "07-27", title: "桃花视频浪漫剧场「古风篇」正式开播", tag: "上新" },
  { id: 5, date: "07-26", title: "全平台新增画中画功能，支持边看边聊", tag: "功能" },
  { id: 6, date: "07-25", title: "糖心视频人气作品「温暖时光」播放量突破百万", tag: "热门" },
  { id: 7, date: "07-24", title: "黑桃视频与知名推理作家合作原创剧本上线", tag: "合作" },
  { id: 8, date: "07-23", title: "妖精视频上线智能推荐算法，精准匹配观影偏好", tag: "更新" },
  { id: 9, date: "07-22", title: "桃花视频「甜蜜邂逅」系列总播放量破500万", tag: "热门" },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-smartphone-line",
    title: "移动端原生适配",
    description: "糖心视频、黑桃视频等全部APP针对手机看视频移动端播放深度优化，iOS与Android双平台完美运行。",
  },
  {
    id: 2,
    icon: "ri-hd-line",
    title: "高清流畅播放",
    description: "支持1080P高清画质，智能码率自适应网络环境，确保手机看视频不卡顿、不延迟。",
  },
  {
    id: 3,
    icon: "ri-download-cloud-2-line",
    title: "离线智能缓存",
    description: "Wi-Fi环境下自动缓存最新内容，外出时零流量观看，让移动端播放更省心省流量。",
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "安全绿色下载",
    description: "所有视频软件均经过安全检测，无恶意代码、无强制广告，保护您的设备与隐私安全。",
  },
  {
    id: 5,
    icon: "ri-refresh-line",
    title: "每日持续更新",
    description: "站内资源每日更新，糖心视频、妖精视频、桃花视频等内容持续上新，永远有新鲜好内容。",
  },
];

export const indexData = [
  { id: 1, name: "糖心视频精选", count: 128, icon: "ri-heart-pulse-line" },
  { id: 2, name: "黑桃视频剧场", count: 96, icon: "ri-movie-2-line" },
  { id: 3, name: "妖精视频热榜", count: 215, icon: "ri-fire-line" },
  { id: 4, name: "桃花视频浪漫", count: 87, icon: "ri-flower-line" },
  { id: 5, name: "苹果视频校园", count: 73, icon: "ri-apple-line" },
  { id: 6, name: "榴莲视频猎奇", count: 64, icon: "ri-emotion-line" },
  { id: 7, name: "移动端播放指南", count: 42, icon: "ri-guide-line" },
  { id: 8, name: "视频软件测评", count: 56, icon: "ri-star-line" },
];

export const aboutData = {
  title: "关于国产91视频",
  description: "国产91视频是专注于移动端视频资源聚合的平台，致力于为广大用户提供糖心视频、黑桃视频、妖精视频、桃花视频等优质视频APP的下载入口与使用指南。我们每日更新最新视频内容资讯，覆盖多元题材，帮助用户发现适合自己的视频软件，畅享手机看视频移动端播放的便捷体验。平台始终坚持安全第一原则，所有推荐的视频软件均经过严格检测，确保用户下载使用无忧。",
  highlights: [
    { label: "上线时间", value: "2019年" },
    { label: "合作APP", value: "50+" },
    { label: "覆盖题材", value: "30+" },
    { label: "日均更新", value: "20+" },
  ],
};

export const contactData = {
  title: "联系我们",
  description: "如有视频APP合作需求、内容推荐或使用问题，欢迎通过以下方式联系我们。我们也开放视频软件投稿通道，优质内容将获得首页推荐位曝光。",
  email: "contact@guochan91.com",
  tips: [
    "合作咨询：视频APP接入、广告投放、品牌联动",
    "内容投稿：原创视频内容推荐、优质资源分享",
    "问题反馈：APP使用问题、播放异常、功能建议",
  ],
};

export const commentsData = [
  {
    id: 1,
    name: "视频爱好者小王",
    date: "2026-07-28",
    content: "糖心视频的画质真的没话说，移动端播放特别流畅。之前用其他APP老是卡顿，换了糖心视频之后体验提升太多了，推荐大家都试试！",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20user%20avatar%20with%20warm%20coral%20gradient%20background%2C%20clean%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20face%2C%20abstract%20circular%20shape&width=80&height=80&seq=avatar-01&orientation=squarish",
  },
  {
    id: 2,
    name: "追剧小达人",
    date: "2026-07-27",
    content: "黑桃视频的悬疑剧太上头了，每晚都忍不住追更。画中画功能太好用了，可以一边聊天一边追剧，移动端播放的体验真的赞。",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20user%20avatar%20with%20amber%20gradient%20background%2C%20clean%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20face%2C%20abstract%20circular%20shape&width=80&height=80&seq=avatar-02&orientation=squarish",
  },
  {
    id: 3,
    name: "深夜放映室",
    date: "2026-07-26",
    content: "妖精视频和桃花视频各有各的好，一个题材多元一个浪漫甜蜜。离线缓存功能拯救通勤党，每天地铁上都有好内容看，真心推荐国产91视频这个平台。",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20user%20avatar%20with%20warm%20rose%20gradient%20background%2C%20clean%20geometric%20style%2C%20modern%20flat%20design%2C%20no%20face%2C%20abstract%20circular%20shape&width=80&height=80&seq=avatar-03&orientation=squarish",
  },
];